module.exports = __webpack_public_path__ + "static/fonts/iconfont.ae58d471.woff";